import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import BillCard from './BillCard';
import EmptyState from './EmptyState';
import { apiFetch } from '../../utils/api';


const BillsTab = ({ onViewBill }) => {
  const { user } = useContext(AuthContext);
  const [bills, setBills] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) return;
    const fetchBills = async () => {
      try {
        setLoading(true);
        const res = await apiFetch('/api/bills');
        const data = await res.json();
        if (res.ok) {
          setBills(Array.isArray(data) ? data : []);
        }
      } catch (error) {
        console.error('Failed to fetch bills:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchBills();
  }, [user]);

  if (loading) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
        <h2 style={{ color: 'var(--color-text-primary)', fontSize: '1.8rem', margin: 0 }}>Bills & Invoices</h2>
        <div className="bills-grid">
          <div className="skeleton bill-card-item" style={{ height: '260px' }} />
          <div className="skeleton bill-card-item" style={{ height: '260px' }} />
          <div className="skeleton bill-card-item" style={{ height: '260px' }} />
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
      
      {/* Title */}
      <h2 style={{ color: 'var(--color-text-primary)', fontSize: '1.8rem', margin: 0 }}>Bills & Invoices</h2>

      {/* Grid of Bills */}
      {bills.length === 0 ? (
        <EmptyState
          icon="📄"
          title="No Bills Available"
          description="Uploaded invoices will appear here."
        />
      ) : (
        <div className="bills-grid">
          {bills.map(bill => (
            <BillCard
              key={bill._id}
              bill={bill}
              onViewBill={onViewBill}
              layout="grid"
            />
          ))}
        </div>
      )}

    </div>
  );
};

export default BillsTab;
